import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button, IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2/index.js'

import { useDropdown } from '_hooks'

export const SORT_TYPES = {
  ALPHABETICAL: 'alphabetical',
  SIZE: 'size',
}

import './styles.scss'

const FilterTopicsButton = ({ className, classes, onSort }) => {
  const { isOpen, handleOpen, handleClose, dropdownRef } = useDropdown()
  const [type, setType] = useState(SORT_TYPES.SIZE)

  useEffect(() => {
    onSort(type)
  }, [type])

  const handleSort = (_, _2, value) => {
    setType(value)
    handleClose()
  }

  return (
    <div className={classnames('sort-topics-button', className, classes?.root)}>
      <IconButton
        iconProps={{ icon: 'sort', type: ICON_TYPES.OUTLINE, width: '16px', height: '16px' }}
        className="sort-topics-button__icon"
        onClick={handleOpen}
        isActive={isOpen}
        ariaLabel="Sort topics"
        text="Sort"
        key="sort-button"
      />
      <If condition={isOpen}>
        <ul
          className={classnames('sort-topics-button__dropdown', classes?.dropdown)}
          key="sort-dropdown"
          ref={dropdownRef}
        >
          <li>
            <Button
              className={classnames('sort-topics-button__option', {
                'sort-topics-button__option--active': type === SORT_TYPES.ALPHABETICAL,
              })}
              value={SORT_TYPES.ALPHABETICAL}
              onClick={handleSort}
            >
              Alphabetical (A-Z)
            </Button>
          </li>
          <li>
            <Button
              className={classnames('sort-topics-button__option', {
                'sort-topics-button__option--active': type === SORT_TYPES.SIZE,
              })}
              value={SORT_TYPES.SIZE}
              onClick={handleSort}
            >
              Number of users (500K-0K)
            </Button>
          </li>
        </ul>
      </If>
    </div>
  )
}

FilterTopicsButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    icon: PropTypes.string,
    dropdown: PropTypes.string,
  }),
  onSort: PropTypes.func,
}

FilterTopicsButton.defaultProps = {
  className: '',
  classes: {},
  onSort: () => {},
}

export default React.memo(FilterTopicsButton)
